module.exports = __webpack_public_path__ + "img/soon.c4fb3d0b.webp";